
import { RANGER_FIREARM_ASSIGNMENT_LOG_METADATA } from './ranger-firearm-assignment-log.metadata';
import { RangerFirearmAssignmentLogBase } from './ranger-firearm-assignment-log.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface RangerFirearmAssignmentLog extends RangerFirearmAssignmentLogBase {
}

export interface RangerFirearmAssignmentLogTransient { }

export class RangerFirearmAssignmentLog extends CrudEntity<RangerFirearmAssignmentLog, string, RangerFirearmAssignmentLogTransient> implements RangerFirearmAssignmentLogTransient {
  constructor(source?: Partial<RangerFirearmAssignmentLog>, options?: CrudEntityConstructionOptions<RangerFirearmAssignmentLog, string, RangerFirearmAssignmentLogTransient>) {
    super(RANGER_FIREARM_ASSIGNMENT_LOG_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





